export default {
  "home": "首頁",
  "news": "最新資訊",
  "community": "社群資訊",
  "character": "角色介紹",
  "world": "世界觀",
  "features": "遊戲特色",
  "topUp": "儲值購點",
  "customerService": "客服中心",
  "download": "立即下載",
  "moreDownload": "更多下載方式",
  "screenshot": "截圖",
  "video": "影片",
  "poster": "海報",
  "downloadGame": "下載遊戲",
  "scan": "掃一掃下載遊戲",
  "prev": "上一頁",
  "next": "下一頁",
  "moreNews": "更多資訊",
  "latest": "最新",
  "fwtk": "服務條款",
  "yszc": "隱私政策",
  "noContent": "暫無文章，敬請期待",
  "goPay": "立即前往",
  "payGuide": "瞭解詳情",
  "stayTurn": "敬請期待",
  "back": "返回",
  "reserveNow": "立即预约",
}
